type FluidImage = {
  fluid?: {
    src?: string | null;
    aspectRatio?: number | null;
  } | null;
} | null;

export type DownloadPreviewImage = {
  src: string;
  aspectRatio: number;
};

const toPreviewImage = (image: FluidImage | null | undefined): DownloadPreviewImage | null => {
  if (!image?.fluid?.src) {
    return null;
  }

  return {
    src: image.fluid.src,
    aspectRatio: image.fluid.aspectRatio ?? 16 / 9,
  };
};

export const resolveDownloadPreviewImages = (
  previewImages: ReadonlyArray<FluidImage> | null | undefined,
  documentCover: FluidImage | null | undefined,
): DownloadPreviewImage[] => {
  const fromPreview = (previewImages ?? [])
    .map(toPreviewImage)
    .filter((image): image is DownloadPreviewImage => image !== null);

  if (fromPreview.length > 0) {
    return fromPreview;
  }

  const cover = toPreviewImage(documentCover);
  return cover ? [cover] : [];
};

/** 詳細ページスライダー用。1枚目は documentCover、2枚目以降は previewImages */
export const resolveDownloadSliderImages = (
  previewImages: ReadonlyArray<FluidImage> | null | undefined,
  documentCover: FluidImage | null | undefined,
): DownloadPreviewImage[] => {
  const slides: DownloadPreviewImage[] = [];
  const cover = toPreviewImage(documentCover);

  if (cover) {
    slides.push(cover);
  }

  (previewImages ?? []).forEach((image) => {
    const preview = toPreviewImage(image);
    if (preview && !slides.some((slide) => slide.src === preview.src)) {
      slides.push(preview);
    }
  });

  return slides;
};

export const getDownloadOgpImageUrl = (
  previewImages: ReadonlyArray<FluidImage> | null | undefined,
  documentCover: FluidImage | null | undefined,
): string => {
  const cover = toPreviewImage(documentCover);
  if (cover) {
    return `https:${cover.src}`;
  }

  const images = resolveDownloadPreviewImages(previewImages, documentCover);
  return images[0] ? `https:${images[0].src}` : "";
};
